import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { resetPayrollComponentDetailState, getPayrollComponentDetail as onGetPayrollComponentDetails, addNewPayrollComponentDetail as onAddNewPayrollComponentDetail, updatePayrollComponentDetail as onUpdatePayrollComponentDetail, deletePayrollComponentDetail as onDeletePayrollComponentDetail, getPayrollComponentDetailLoading } from "../../../store/payrollComponentDetail/action";
import { getPayrollComponent as onGetPayrollComponents, addNewPayrollComponent as onAddNewPayrollComponent, updatePayrollComponent as onUpdatePayrollComponent, deletePayrollComponent as onDeletePayrollComponent, getPayrollComponentLoading, resetPayrollComponentState } from "../../../store/payrollComponent/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const PayrollComponent = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, payrollComponents, isPayrollComponentCreated, isPayrollComponentSuccess, loading, error, payrollComponentDetails, payrollComponentDetailLoading, isPayrollComponentDetailCreated, isPayrollComponentDetailSuccess, companies, companyLoading, accAccounts } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    payrollComponents: state.PayrollComponent.payrollComponents,
    isPayrollComponentCreated: state.PayrollComponent.isPayrollComponentCreated,
    isPayrollComponentSuccess: state.PayrollComponent.isPayrollComponentSuccess,
    loading: state.PayrollComponent.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.PayrollComponent.error,
    payrollComponentDetails: state.PayrollComponentDetail.payrollComponentDetails,
    payrollComponentDetailLoading: state.PayrollComponentDetail.loading,
    isPayrollComponentDetailCreated: state.PayrollComponentDetail.isPayrollComponentDetailCreated,
    isPayrollComponentDetailSuccess: state.PayrollComponentDetail.isPayrollComponentDetailSuccess,
    accAccounts: state.AccAccount.accAccounts,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [payrollComponentList, setPayrollComponentList] = useState([]);
  const [payrollComponent, setPayrollComponent] = useState([]);
  const [componentDetailAddedId, setComponentDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [payrollComponentDetail, setPayrollComponentDetail] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [componentType, setComponentType] = useState("");
  const [amountType, setAmountType] = useState("");
  const [componentTypeCategory, setComponentTypeCategory] = useState("");
  const [periodType, setPeriodType] = useState("");
  const [selectedAllowance, setSelectedAllowance] = useState([]);
  const [accountingList, setAccountingList] = useState([]);

  const componentTypeData = [
    {
      options: [
        { label: "Tunjangan", value: "Allowance" },
        { label: "Potongan", value: "Deduction" },
        { label: "Bonus", value: "Bonus" },
        { label: "THR Bonus", value: "THR Bonus" },
        { label: "KPI Bonus", value: "KPI Bonus" },
        { label: "Sales Bonus", value: "Sales Bonus" },
        { label: "Kompensasi Pengunduran Diri", value: "Resign Compensation" },
      ],
    },
  ];

  const componentTypeCategoryAllowanceData = [
    {
      options: [
        { label: "Custom", value: "Custom" },
        { label: "BPJS Kesehatan", value: "BPJS Kesehatan" },
        { label: "JHT", value: "JHT" },
        { label: "JP", value: "JP" },
        { label: "JKK", value: "JKK" },
        { label: "JKM", value: "JKM" },
      ],
    },
  ];

  const componentTypeCategoryDeductionData = [
    {
      options: [
        { label: "Custom", value: "Custom" },
        { label: "Savings", value: "Savings" },
        // { label: "Loan", value: "Loan" },
        // { label: "Over Payment", value: "Over Payment" },
        { label: "Unpaid Leave", value: "Unpaid Leave" },
        { label: "Absent Compensation", value: "Absent Compensation" },
        { label: "BPJS Kesehatan", value: "BPJS Kesehatan" },
        { label: "JHT", value: "JHT" },
        { label: "JP", value: "JP" },
        { label: "JKK", value: "JKK" },
        { label: "JKM", value: "JKM" },
      ],
    },
  ];

  const amountTypeData = [
    {
      options: [
        { label: "Jumlah Sesuai Kebutuhan", value: "Custom Amount" },
        { label: "Gaji", value: "Salary" },
        { label: "Gaji Dengan Tunjangan", value: "Salary With Allowance" },
        { label: "Sales Per Pcs", value: "Sales Per Pcs" },
      ],
    },
  ];

  const periodTypeData = [
    {
      options: [
        { label: "Harian", value: "Daily" },
        { label: "Bulanan", value: "Monthly" },
        { label: "Satu Waktu", value: "One Time" },
      ],
    },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [companyName, setCompanyName] = useState({});

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const onClickDelete = (payrollComponent) => {
    setPayrollComponent(payrollComponent);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (payrollComponentDetail) => {
    setPayrollComponentDetail(payrollComponentDetail);
    setDeleteModalDetail(true);
  };

  const handleDeletePayrollComponent = () => {
    if (payrollComponent) {
      dispatch(onDeletePayrollComponent(payrollComponent));
      setDeleteModal(false);
    }
  };

  const handleDeletePayrollComponentDetail = () => {
    if (payrollComponentDetail) {
      setComponentDetailAddedId(payrollComponentDetail.componentId);
      dispatch(onDeletePayrollComponentDetail(payrollComponentDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setPayrollComponent(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPayrollComponents = payrollComponents;
      if (type !== "all") {
        filteredPayrollComponents = payrollComponents.filter((payrollComponent) => payrollComponent.pc_status.name === type);
      }
      setPayrollComponentList(filteredPayrollComponents);
    }
  };

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetPayrollComponentState());
      dispatch(onGetPayrollComponents({ companyId: companySelected?.value ?? "" }));
      dispatch(resetAccAccountState());
      dispatch(getAccAccount());
    }
  }, [companySelected]);

  useEffect(() => {
    if (info && info.id) {
      dispatch(
        onGetPayrollComponentDetails({
          componentId: info.id,
        })
      );
    }
  }, [dispatch, info, payrollComponents]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const account_name = item.name;
        const account_code = item.code;
        const id = item.id;
        var obj = { label: account_code + " " + account_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(payrollComponents)) {
      setIsEdit(false);
      let filteredPayrollComponents = payrollComponents;
      if (activeTypeTab !== "all") {
        filteredPayrollComponents = payrollComponents.filter((payrollComponent) => payrollComponent.pc_status.name === activeTypeTab);
      }
      setPayrollComponentList(filteredPayrollComponents);
      let current = 0;
      if (componentDetailAddedId !== 0) {
        payrollComponents.forEach((obj, i) => {
          if (obj.id === componentDetailAddedId) current = i;
        });
      }
      setInfo(payrollComponents[current]);
    }
  }, [payrollComponents, componentDetailAddedId]);

  useEffect(() => {
    if (isPayrollComponentDetailCreated) {
      dispatch(resetPayrollComponentDetailState());
      dispatch(resetPayrollComponentState());
      dispatch(onGetPayrollComponents());
    }
  }, [dispatch, isPayrollComponentDetailCreated]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const [filterDate, setFilterDate] = useState(null);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPayrollComponent(null);
      // validation.resetForm();
      // validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal, dispatch]);

  const handlePayrollComponentClick = useCallback(
    (arg) => {
      const data = arg;
      setPayrollComponent({
        id: data.id,
        name: data.name,
        client: data.pc_client && {
          label: data.pc_client ? data.pc_client.name : "",
          value: data.pc_client ? data.pc_client.id : "",
        },
        company: data.pc_company && {
          label: data.pc_company ? data.pc_company.name : "",
          value: data.pc_company ? data.pc_company.id : "",
        },
      });
      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setSelectedAllowance([]);
      setPayrollComponentDetail(null);
      setPayrollComponent(null);
      setAmountType("");
      setComponentType("");
      setPeriodType("");
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handlePayrollComponentDetailClick = useCallback(
    (arg, arginfo, isEdit) => {
      const data = arg;

      var allowance = [];
      var opt = [{ label: "Select All", value: "all" }];
      arginfo.pc_detail &&
        arginfo.pc_detail.forEach((item, key) => {
          if (item.component_type === "Allowance") {
            const name = item.name;
            const id = item.id;
            var obj = { label: name, value: id };
            opt.push(obj);
          }
        });
      var option = { options: opt };
      allowance.push(option);
      setSelectedAllowance(allowance);

      let selectedallowancedata;
      if (data.pcd_allowance && data.pcd_allowance.length) {
        selectedallowancedata = [];
        data.pcd_allowance.forEach((item) => {
          const name = item.pcds_detail.name;
          const id = item.selectedId;
          var obj = { label: name, value: id };
          selectedallowancedata.push(obj);
        });
      }

      setAmountType(data.amount_type);
      setComponentType(data.component_type);
      setPeriodType(data.period_type);
      setPayrollComponentDetail({
        id: data.id,
        name: data.name,
        companyId: data.companyId,
        componentId: data.componentId,
        isTaxable: data.isTaxable,
        byperiod: data.byperiod,
        bypercentage: data.bypercentage,
        byamount: data.byamount,
        selected_allowance: selectedallowancedata,
        component_type: {
          label: data.component_type,
          value: data.component_type,
        },
        component_type_category: {
          label: data.component_type_category,
          value: data.component_type_category,
        },
        amount_type: { label: data.amount_type, value: data.amount_type },
        period_type: { label: data.period_type, value: data.period_type },
        account: data.pcd_acc_account && {
          label: data.pcd_acc_account.name,
          value: data.pcd_acc_account.id,
        },
      });

      setIsEditDetail(isEdit);
      toggleDetail();
    },
    [toggleDetail]
  );

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: " ",
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePayrollComponent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePayrollComponentClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePayrollComponent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusActiveId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approvePayrollComponent") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui jadwal ${data.name} #${data.code}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "pc_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [handlePayrollComponentClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: payrollComponentList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(
    () => [
      {
        id: "#",
        Header: " ",
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePayrollComponent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePayrollComponentDetailClick(data, info, true);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePayrollComponent") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDeleteDetail(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusActiveId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approvePayrollComponent") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui jadwal ${data.name} #${data.code}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: `Nama`,
        accessor: "name",
        filterable: true,
        Cell: (client) => (
          <div className="d-flex align-items-center">
            <div className="flex-grow-1 ms-2 name">{client.row.original.image !== null ? client.row.original.name : "-"}</div>
          </div>
        ),
      },

      {
        Header: "Komponen",
        accessor: "component_type",
        filterable: true,
      },
      {
        Header: "Periode",
        accessor: "period_type",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "document_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [handlePayrollComponentDetailClick, info]
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveComponent = () => {
    if (payrollComponent) {
      payrollComponent.setApprove = true;
      dispatch(onUpdatePayrollComponent(payrollComponent));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (payrollComponent && payrollComponent.name) ?? "",
      client: (payrollComponent && payrollComponent.client) || clientSelected,
      company: (payrollComponent && payrollComponent.company) || companySelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Component Name").nullable(true),
      company: Yup.object().required("Please Enter company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPayrollComponentLoading());
      if (isEdit) {
        const updatePayrollComponent = {
          id: payrollComponent ? payrollComponent.id : 0,
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          statusId: 2,
        };
        dispatch(onUpdatePayrollComponent(updatePayrollComponent));
        validation.resetForm();
      } else {
        const newPayrollComponent = {
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          statusId: 2,
        };
        dispatch(onAddNewPayrollComponent(newPayrollComponent));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      componentId: (payrollComponentDetail && payrollComponentDetail.componentId) || (payrollComponent && payrollComponent.id),
      name: (payrollComponentDetail && payrollComponentDetail.name) ?? "",
      isTaxable: (payrollComponentDetail && payrollComponentDetail.isTaxable) || false,
      byperiod: (payrollComponentDetail && payrollComponentDetail.byperiod) || null,
      bypercentage: (payrollComponentDetail && payrollComponentDetail.bypercentage) || 100,
      byamount: (payrollComponentDetail && payrollComponentDetail.byamount) || 0,
      component_type: (payrollComponentDetail && payrollComponentDetail.component_type) ?? "",
      amount_type: (payrollComponentDetail && payrollComponentDetail.amount_type) ?? "",
      period_type: (payrollComponentDetail && payrollComponentDetail.period_type) ?? "",
      selected_allowance: (payrollComponentDetail && payrollComponentDetail.selected_allowance) ?? "",
      component_type_category: (payrollComponentDetail && payrollComponentDetail.component_type_category) ?? "",
      account: (payrollComponentDetail && payrollComponentDetail.account) ?? "",
    },
    validationSchema: Yup.object({
      component_type: Yup.object().required("Please Enter Component Type").nullable(true),
      amount_type: Yup.object().required("Please Enter Amount Type").nullable(true),
      period_type: Yup.object().required("Please Enter Period Type").nullable(true),
      name: Yup.string().required("Please Enter Component Name").nullable(true),
    }),
    onSubmit: (values) => {
      setComponentDetailAddedId(values.componentId);
      dispatch(getPayrollComponentLoading());
      if (isEditDetail) {
        const updatePayrollComponentDetail = {
          id: payrollComponentDetail ? payrollComponentDetail.id : 0,
          name: values.name,
          component_type: values.component_type.value,
          component_type_category: values.component_type_category.value,
          amount_type: values.amount_type.value,
          period_type: values.period_type.value,
          isTaxable: values.isTaxable,
          byperiod: values.byperiod,
          bypercentage: values.bypercentage,
          byamount: values.byamount,
          componentId: values.componentId,
          selected_allowance: values.selected_allowance,
          accId: values.account.value,
        };
        dispatch(onUpdatePayrollComponentDetail(updatePayrollComponentDetail));
        validationDetail.resetForm();
      } else {
        const newPayrollComponentDetail = {
          name: values.name,
          component_type: values.component_type.value,
          component_type_category: values.component_type_category.value,
          amount_type: values.amount_type.value,
          period_type: values.period_type.value,
          isTaxable: values.isTaxable,
          byperiod: values.byperiod,
          bypercentage: values.bypercentage,
          byamount: values.byamount,
          componentId: values.componentId,
          selected_allowance: values.selected_allowance,
          accId: values.account.value,
        };
        dispatch(onAddNewPayrollComponentDetail(newPayrollComponentDetail));
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePayrollComponentDetail(element.value));
    });
    checkall.checked = false;
  };

  function handlePayrollComponentStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetPayrollComponents(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPayrollComponentList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetPayrollComponentState());
    dispatch(onGetPayrollComponents({ companyId: companySelected?.value ?? "" }));
  };

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: payrollComponentDetails,
      defaultColumn: { Filter: null },
      // initialState: {
      //   pageIndex: 0,
      //   // pageSize: 8,
      //   selectedRowIds: 0,
      //   sortBy: [
      //     {
      //       desc: false,
      //     },
      //   ],
      // },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const countSecond = preGlobalFilteredRowsSecond.length;
  const [searchValueSecond, setSearchValueSecond] = useState([]);
  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);

  document.title = "Komponen Gaji | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ApproveModal data={payrollComponent && payrollComponent.contract_employee ? payrollComponent.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveComponent} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePayrollComponent} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeletePayrollComponentDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Penggajian" pageTitle="Komponen Gaji" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPayrollComponent") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col sm={5}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i>SEMUA KOMPONEN GAJI
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>
                        DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>
                        ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>
                        INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Komponen Gaji" : "Tambah Komponen Gaji"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;{" "}
                            {clientLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              validation.setFieldValue("client", e);
                            }}
                            options={clientList}
                          ></Select>
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp;{" "}
                            {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            onChange={(e) => {
                              dispatch(setBranchSelect(null));
                              dispatch(setCompanySelect(e));
                              validation.setFieldValue("company", e);
                            }}
                            options={companyList}
                          ></Select>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name-field" className="form-label">
                            Nama Komponen
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Komponen" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                          {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Batal
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Ubah Komponen" : "Tambah Komponen"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="name-field" className="form-label">
                            Nama Komponen
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Detail Komponen" type="text" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.name} invalid={validationDetail.touched.name && validationDetail.errors.name ? true : false} />
                          {validationDetail.touched.name && validationDetail.errors.name ? <FormFeedback type="invalid">{validationDetail.errors.name}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="component_type" className="form-label">
                            Tipe Komponen
                          </Label>
                          <Select
                            name="component_type"
                            placeholder="Pilih Tipe Komponen"
                            value={validationDetail.values.component_type}
                            onChange={(e) => {
                              validationDetail.setFieldValue("component_type", e);
                              if (e.value === "THR Bonus" || e.value === "Bonus" || e.value === "KPI Bonus" || e.value === "Sales Bonus") {
                                validationDetail.setFieldValue("component_type_category", { label: e.value, value: e.value });
                              } else {
                                validationDetail.setFieldValue("component_type_category", null);
                              }
                              validationDetail.setFieldValue("amount_type", null);
                              validationDetail.setFieldValue("period_type", null);
                              validationDetail.setFieldValue("selected_allowance", null);
                              setComponentType(e.value);
                            }}
                            options={componentTypeData}
                          ></Select>
                          {validationDetail.touched.component_type && validationDetail.errors.component_type ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.component_type}
                            </small>
                          ) : null}
                        </div>
                        {(componentType === "Deduction" || componentType === "Allowance") && (
                          <div className="mb-3 col-lg-12">
                            <Label htmlFor="component_type_category-field" className="form-label">
                              {componentType} Categories
                            </Label>
                            <Select
                              name="component_type_category"
                              placeholder="Enter Category"
                              value={validationDetail.values.component_type_category}
                              onChange={(e) => {
                                validationDetail.setFieldValue("component_type_category", e);
                                validationDetail.setFieldValue("period_type", null);
                                setComponentTypeCategory(e.value);
                              }}
                              options={componentType === "Deduction" ? componentTypeCategoryDeductionData : componentTypeCategoryAllowanceData}
                            ></Select>
                          </div>
                        )}
                        <div className={amountType !== "" ? "mb-3 col-lg-7" : "mb-3 col-lg-12"}>
                          <Label htmlFor="amount_type" className="form-label">
                            Tipe Jumlah
                          </Label>
                          <Select
                            name="amount_type"
                            placeholder="Pilih Tipe Jumlah"
                            value={validationDetail.values.amount_type}
                            onChange={(e) => {
                              validationDetail.setFieldValue("amount_type", e);
                              validationDetail.setFieldValue("selected_allowance", null);
                              setAmountType(e.value);
                            }}
                            options={amountTypeData}
                            filterOption={(option) => (componentType === "Sales Bonus" ? option.value !== "Custom Amount" && option.value !== "Salary" && option.value !== "Salary With Allowance" : option.value !== "Sales Per Pcs")}
                          ></Select>
                          {validationDetail.touched.amount_type && validationDetail.errors.amount_type ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.amount_type}
                            </small>
                          ) : null}
                        </div>
                        {(amountType === "Custom Amount" || amountType === "Sales Per Pcs") && (
                          <div className="mb-3 col-lg-5">
                            <Label htmlFor="byamount-field" className="form-label">
                              Jumlah
                            </Label>
                            <Input name="byamount" id="byamount-field" className="form-control" placeholder="Enter Amount" type="number" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.byamount} />
                          </div>
                        )}
                        {(amountType === "Salary" || amountType === "Salary With Allowance") && (
                          <div className="mb-3 col-lg-5">
                            <Label htmlFor="bypercentage-field" className="form-label">
                              Persen %
                            </Label>
                            <Input name="bypercentage" id="bypercentage-field" className="form-control" min="1" placeholder="Enter Percentage" type="text" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.bypercentage} />
                          </div>
                        )}
                        {amountType === "Salary With Allowance" && (
                          <div className="mb-3">
                            <Label htmlFor="selected_allowance" className="form-label">
                              Tunjangan
                            </Label>
                            <Select
                              name="selected_allowance"
                              placeholder="Select Allowance"
                              value={validationDetail.values.selected_allowance}
                              isMulti
                              onChange={(opt, { option }) => {
                                let newOpts = !!isEditDetail ? [] : opt;
                                if (option && option.value === "all") {
                                  let filteredOptions = clone(selectedAllowance);
                                  filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                  newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                } else {
                                  newOpts = opt;
                                }
                                validationDetail.setFieldValue("selected_allowance", newOpts);
                              }}
                              options={selectedAllowance}
                            ></Select>
                          </div>
                        )}
                        <div className={periodType === "One Time" && componentType !== "Resign Compensation" ? "mb-3 col-lg-7" : "mb-3 col-lg-12"}>
                          <Label htmlFor="period_type" className="form-label">
                            Tipe Periode
                          </Label>
                          <Select
                            name="period_type"
                            placeholder="Pilih Tipe Periode"
                            value={validationDetail.values.period_type}
                            onChange={(e) => {
                              validationDetail.setFieldValue("period_type", e);
                              setPeriodType(e.value);
                            }}
                            options={periodTypeData}
                            filterOption={(option) => {
                              if (componentType === "THR Bonus" || componentType === "KPI Bonus" || componentType === "Resign Compensation") {
                                return option.value !== "Daily" && option.value !== "Monthly";
                              } else if (componentTypeCategory === "Absent Compensation" || componentTypeCategory === "Unpaid Leave" || componentTypeCategory === "BPJS Kesehatan" || componentTypeCategory === "JHT" || componentTypeCategory === "JP" || componentTypeCategory === "JKK" || componentTypeCategory === "JKM") {
                                return option.value !== "Daily" && option.value !== "One Time";
                              } else {
                                return option.value !== "";
                              }
                            }}
                          ></Select>
                          {validationDetail.touched.period_type && validationDetail.errors.period_type ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.period_type}
                            </small>
                          ) : null}
                        </div>
                        {periodType === "One Time" && componentType !== "Resign Compensation" && (
                          <div className="mb-3 col-lg-5">
                            <Label htmlFor="byperiod-field" className="form-label">
                              Tanggal Periode Penggajian
                            </Label>
                            <Flatpickr
                              name="byperiod"
                              id="byperiod-field"
                              className="form-control"
                              placeholder="Select One Time Date"
                              options={{
                                enableTime: false,
                                dateFormat: "Y/m/d",
                              }}
                              value={validationDetail.values.byperiod}
                              onChange={(o, e) => {
                                validationDetail.setFieldValue("byperiod", e);
                              }}
                            />
                          </div>
                        )}
                        <div className="mb-3">
                          <label className="form-label" htmlFor="account">
                            Akun
                          </label>
                          <Select
                            name="account"
                            value={validationDetail.values.account}
                            placeholder="Pilih Akun"
                            onChange={(e) => {
                              validationDetail.setFieldValue("account", e);
                            }}
                            options={accountingList}
                          ></Select>
                          {validationDetail.touched.account && validationDetail.errors.account && (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.account}
                            </small>
                          )}
                        </div>
                        <div className="mb-3">
                          <Input name="isTaxable" id="isTaxable-field" className="form-check-input" type="checkbox" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} checked={validationDetail.values.isTaxable} /> &nbsp;
                          <Label htmlFor="isTaxable-field" className="form-label">
                            Kena Pajak
                          </Label>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col sm={7}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info ? info.name : " - "}</h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-success add-btn" : userRole && userRole.split(",").indexOf("createPayrollComponent") !== -1 ? "btn btn-success add-btn" : "btn btn-success add-btn d-none"}
                    id="create-btn"
                    onClick={() => {
                      setPayrollComponent(info);
                      setIsEditDetail(false);
                      toggleDetail();
                      var data = [];
                      var opt = [{ label: "Select All", value: "all" }];
                      info.pc_detail &&
                        info.pc_detail.forEach((item, key) => {
                          if (item.component_type === "Allowance") {
                            const name = item.name;
                            const id = item.id;
                            var obj = { label: name, value: id };
                            opt.push(obj);
                          }
                        });
                      var option = { options: opt };
                      data.push(option);
                      setSelectedAllowance(data);
                    }}
                  >
                    <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                    Tambah Detail
                  </button>
                  <button className="btn btn-soft-danger ms-2" onClick={() => setDeleteModalMulti(true)}>
                    <i className="ri-delete-bin-5-line me-1 align-bottom fs-13"></i>
                  </button>
                </div>
              </div>
              <Row>
                <CardBody className="border border-top-0 border-end-0 border-start-0">
                  <form>
                    <Row>
                      <Col sm={4}>
                        <div className="search-box me-2  d-inline-block col-12 ms-3">
                          <input
                            onChange={(e) => {
                              setSearchValueSecond(e.target.value);
                              onChangeSecond(e.target.value);
                            }}
                            id="search-bar-0"
                            type="text"
                            className="form-control search"
                            placeholder={`${countSecond} Cari...`}
                            value={searchValueSecond ?? ""}
                          />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Row>
              <div className="card-body ">
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PayrollComponent;
